"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const client_1 = __importDefault(require("react-dom/client"));
const utils_1 = require("./utils");
class Renderer {
    constructor(mountedRoots, options) {
        this.mountedRoots = mountedRoots;
        this.options = options;
    }
    // Render synchronous components
    render(element, registered, props) {
        const renderComponent = react_1.default.createElement(registered.component, props);
        const root = this.rootRender(element, renderComponent); // Component is used as a value here
        this.mountedRoots.add(element, { root, componentName: element.getAttribute(this.options.componentAttr), props });
    }
    // Render asynchronous components
    renderAsync(element, registered, props) {
        return __awaiter(this, void 0, void 0, function* () {
            const LazyComponent = react_1.default.lazy(() => {
                return Promise.resolve({ default: registered.component });
            });
            const ReactComponent = react_1.default.createElement(LazyComponent, props);
            const Suspense = react_1.default.createElement(react_1.default.Suspense, { fallback: this.options.loading }, ReactComponent);
            const root = this.rootRender(element, Suspense);
            this.mountedRoots.add(element, root, element.getAttribute(this.options.componentAttr), props);
        });
    }
    rootRender(element, renderComponent) {
        const root = client_1.default.createRoot(element);
        root.render(renderComponent);
        //remove props attributes
        this.removePropsAttribures(element);
        return root;
    }
    removePropsAttribures(element) {
        element.removeAttribute(this.options.propsAttr);
        //also remove all data-prop-* attributes
        Object.keys(element.dataset).forEach((key) => {
            if (key.startsWith("prop")) {
                const propName = (0, utils_1.kebabize)(key);
                element.removeAttribute(`data-${propName}`);
            }
        });
    }
}
exports.default = Renderer;
